export default "__VITE_ASSET__COGZP$7N__"